import * as React from "react";
import { memo } from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 10,
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.5,
      strokeWidth: 2,
      d: "m6 2 6 6 6-6"
    }
  )
);
const Memo = memo(SvgChevron);
export default Memo;
